import React, {PureComponent} from 'react';

import Error from '../Error';
import TrendWidget from './TrendWidget';
import SummaryWidget from './SummaryWidget';
import BarChartWidget from './BarChartWidget';
import Widget from '../Widget';
import NoDataWidget from '../NoDataWidget';
import Dialog from '../Dialog';
import Button from '../Button';

class TemplateWidget extends PureComponent {
  state = {
    error: false,
    confirmDelete: false
  };

  componentDidCatch() {
    const {onError} = this.props;
    this.setState({error: true}, onError);
  }

  handleEditWidget = () => {
    const {onEdit, widget} = this.props;
    onEdit(widget);
  }

  toggleConfirmDelete = () => {
    this.setState(state => ({confirmDelete: !state.confirmDelete}));
  }

  handleDeleteWidget = () => {
    const {onDelete, widget} = this.props;
    onDelete(widget);
  }

  render() {
    const {widget, sheetsById, rows, questions, onHide, preview, id, user} = this.props;
    const {error, confirmDelete} = this.state;

    let CustomWidget;

    if (widget.groupByQuestion) {
      CustomWidget = BarChartWidget;
    }
    else if (widget.aggregation) {
      CustomWidget = SummaryWidget;
    }
    else {
      CustomWidget = TrendWidget;
    }

    const parsedWidget = {
      ...widget,
      map: JSON.parse(widget.map),
      filter: JSON.parse(widget.filter)
    };

    let userOptions = []

    if(user.role !== "USER") {
      userOptions = [
        {title: 'Hide', onClick: () => onHide({source: 'TemplateWidget', widget})},
        {title: 'Edit', onClick: this.handleEditWidget},
        {title: 'Delete', onClick: this.toggleConfirmDelete}
      ]
    }

    return (
      <Widget
        preview={preview}
        id={id} 
        title={widget.title} 
        options={userOptions}
        overlay={confirmDelete && (
          <Dialog
            title="Delete this widget?"
            description="Are you sure you want to delete this widget? This cannot be undone."
            buttons={[
              <Button key="confirm-delete" onClick={this.handleDeleteWidget}>Delete</Button>,
              <Button key="cancel-delete" secondary onClick={this.toggleConfirmDelete}>Cancel</Button>
            ]}
          />
        )}>
        {error ? (
          <Error message="There is a problem with this widget's configuration" />
        ) : rows.length < 1 ? (
          <NoDataWidget
            id={widget.id} 
            title={widget.title}
            preview={preview}
            options={userOptions}
          />
        ) : (
          <CustomWidget 
            id={widget.id}
            widget={parsedWidget}
            title={widget.title}
            options={userOptions}
            sheetsById={sheetsById}
            rows={rows}
            questions={questions}
            preview={preview}
          />
        )}
      </Widget>
    );
  }
}

export default TemplateWidget;
